import React from 'react';
import PropTypes from "prop-types";
import css from './LabelledRadioOption.scss'
import classnames from "classnames";

const LabelledRadioOption = ({customClass, isChecked, label, radioGroupName, labelId, onRadioSelect, disabled}) => {
    return (
        <div className={classnames(css['radio-options'], customClass)}>
            <input type="radio"
                   aria-labelledby={labelId}
                   name={radioGroupName}
                   onChange={onRadioSelect}
                   checked={isChecked}
                   disabled={disabled || false} />
            <label id={labelId} className={css['radio-label']}>{label}</label>
        </div>
    );
};

LabelledRadioOption.propTypes = {
    customClass: PropTypes.string,
    radioGroupName: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    labelId: PropTypes.string.isRequired,
    onRadioSelect: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

export default LabelledRadioOption;
